import { config } from "@/config/env";
import { PostHogProvider } from "posthog-js/react";
import { PropsWithChildren } from "react";

export function PosthogProvider({ children }: PropsWithChildren) {
  if (config.isDevelopment) {
    return <>{children}</>;
  }

  const apiKey = config.posthogKey;
  if (!apiKey) {
    throw new Error(
      "Missing API Key. Please set VITE_PUBLIC_POSTHOG_API_KEY in your .env",
    );
  }

  const host = config.posthogHost;
  if (!host) {
    throw new Error(
      "Missing Host. Please set VITE_PUBLIC_POSTHOG_HOST in your .env",
    );
  }

  return (
    <PostHogProvider
      apiKey={apiKey}
      options={{
        api_host: host,
        defaults: "2025-05-24",
        capture_exceptions: true,
      }}
    >
      {children}
    </PostHogProvider>
  );
}
